import { ReactNode } from "react";

interface ModalProps {
  open: boolean;
  title: string;
  children?: ReactNode;
  onClose: () => void;
  size?: "sm" | "md" | "lg" | "xl" | "2xl";
}

export default function Modal({
  open,
  title,
  children,
  onClose,
  size = "md",
}: ModalProps) {
  if (!open) return null;

  const sizeClass = {
    sm: "w-[400px]",
    md: "w-[500px]",
    lg: "w-[700px]",
    xl: "w-[900px]",
    "2xl": "w-[1100px]",
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Background */}
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />

      {/* Modal */}
      <div
        className={`
          relative
          bg-white
          rounded-3xl
          shadow-2xl
          max-w-[95vw]
          p-8
          ${sizeClass[size]}
        `}>
        <h2 className="mb-8 text-3xl font-bold">{title}</h2>

        {children}
      </div>
    </div>
  );
}
